export default __webpack_public_path__ + "static/4-4cdbf92e9213cf4490f171a676b30b9d.jpeg";